<template>

  <div>
    <toolbar medium>
      <template v-slot:head>
        {{ $tc('checklists.entity-name', 2) }}
      </template>
    </toolbar>

    <checklists-in
      :items="items"
      :options="options"
      :required-toggle="true"
      @change="add($event)"
      @remove="remove($event)"
      @required="required($event)"
    ></checklists-in>
  </div>

</template>

<script>
  import Toolbar from '../../../shared/toolbar'
  import ChecklistsIn from '../../../checklists/components/checklists-in'

  export default {
    name: 'asset-type-checklists',

    props: [ 'assetType' ],

    computed: {
      items () {
        return this.assetType.checklistsInAssetTypes
      },

      options () {
        const existing = this.items.map(item => item.checklist.id)
        return this.$store.state.items['checklists'].filter(chl => !existing.includes(chl.id))
      }
    },

    methods: {
      async add (item) {
        const result = await this.$store.dispatch('updateItem', {
          modelName: 'checklists-in-asset-types',
          item: {
            assetTypeId: this.assetType.id,
            checklistId: item.checklistId
          }
        })

        this.$emit('change', result)
      },

      async remove (id) {
        await this.$store.dispatch('destroyItem', { model: { name: 'checklists-in-asset-types' }, id })
        this.$emit('remove', id)
      },

      async required (item) {
        await this.$store.dispatch('updateItem', { modelName: 'checklists-in-asset-types', item })
      }
    },

    components: {
      Toolbar,
      ChecklistsIn
    }
  }
</script>

<style scoped lang="scss">

</style>
